import {TenderContractsAllComponent, TenderContractsAwaitingBidsComponent} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAwaitingBidsResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsAwaitingBidsRoute: Route = {
    path: 'awaiting-bids',
    component: TenderContractsAwaitingBidsComponent,
    resolve: {
        contracts: TenderContractsAwaitingBidsResolver,
    },
};
